<script setup lang="ts">
type Props = { item?: CommentArticle | null }

const props = withDefaults(defineProps<Props>(), {})

const app = useNuxtApp()
const route = useRoute()

const date = computed(() => {
  return useDayjs(props.item.created_at).format('YYYY-MM-DD HH:mm')
})

const onClickEdit = () => {
  const page = route.query.page ? app.$anyToInteger(route.query.page, null) : null
  navigateTo(`/imbbs?edit=${props.item.id}${page !== null ? `&page=${page}` : ''}`)
}

const onClickDelete = () => {
  navigateTo(`/imbbs?delete=${props.item.id}`)
}
</script>

<template>
  <div>
    <div class="c-entryContent">
      <div class="c-entryContent_head">
        <p class="c-entryContent_title">
          {{ item.title }}
        </p>
        <div class="c-entryContent_meta">
          <span class="c-entryContent_author">投稿者: <span>{{ item.name }}</span></span><span class="c-entryContent_date">投稿日: <span>{{ date }}</span></span>
        </div>
      </div>
      <div class="c-entryContent_body">
        <div
          class="c-entryContent_content"
          v-html="item.comment.replace(/\n/g, '<br>')"
        />
      </div>
      <div class="c-entryContent_foot">
        <button
          class="c-entryContent_footItem"
          v-on:click="onClickEdit"
        >
          編集
        </button>
        <button
          class="c-entryContent_footItem"
          v-on:click="onClickDelete"
        >
          削除
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="@/components/imbbs.scss" scoped></style>
